<div *ngIf="pageLoading1" class="loader text-center">
	<img src="../../assets/img/loading.gif" />
	<p style="color: black;font-weight: bolder;">Loading...</p>
</div>
@if ((!uId && navbar.user?.tms_access?.create_holiday) || (uId && navbar.user?.tms_access?.edit_holiday)) {
<form [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm">
	<div class="row mb-3">
		<div class="col-lg-9 col-md-9 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('name')}" id="name"
					formControlName="name" placeholder="" />
				<label for="name">Holiday*</label>
			</div>
			<p *ngIf="showError('name')" class="text-danger">
				<span *ngIf="f.name.errors?.required">
					Required
				</span>
				<span *ngIf="f.name.errors?.incorrect">
					{{customError.name}}
				</span>
			</p>
		</div>
		<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
			<div class="input-group">
				<div class="form-floating">
					<input class="form-control" [ngClass]="{'is-invalid':showError('date')}" placeholder=""
						formControlName="date" ngbDatepicker id="date" #date="ngbDatepicker" [minDate]="minDate"
						[container]="'body'" />
					<label for="date">Date*</label>
				</div>
				<button class="btn btn-outline-secondary" (click)="date.toggle()" type="button">
					<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
				</button>
			</div>
			<p *ngIf="showError('date')" class="text-danger">
				<span *ngIf="f.date.errors?.required">
					Required
				</span>
				<span *ngIf="f.date.errors?.ngbDate">
					Invalid
				</span>
				<span *ngIf="f.date.errors?.incorrect">
					{{customError.date}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<button type="submit" class="btn btn-sm btn-primary me-1">
				<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
				<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
				Submit
			</button>
			<button type="button" class="btn btn-sm btn-secondary" (click)="clearForm();">Cancel</button>
		</div>
	</div>
</form>
}@else {
<div>
	<h3 class="text-center">You don't have access to this section.</h3>
</div>
}